import type { FC, PropsWithChildren } from "react"
import { useRef } from "react"
import HoverSyncContext from "helpers/contexts/HoverSyncContext"
import type { HoverSyncContextValue, HoverState } from "helpers/contexts/HoverSyncContext"

type HoverCallback = (state: HoverState | null) => void

const HoverSyncProvider: FC<PropsWithChildren> = ({ children }) => {
  const valueRef = useRef<HoverSyncContextValue | null>(null)

  if (!valueRef.current) {
    const subscribers = new Set<HoverCallback>()

    valueRef.current = {
      subscribe(cb: HoverCallback) {
        subscribers.add(cb)
        return () => {
          subscribers.delete(cb)
        }
      },
      publish(state: HoverState | null) {
        subscribers.forEach((cb) => cb(state))
      },
    }
  }

  return (
    <HoverSyncContext.Provider value={valueRef.current}>
      {children}
    </HoverSyncContext.Provider>
  )
}

export default HoverSyncProvider
